import { tabsAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  tabsAnatomy.keys
)

const baseStyle = {
  tab: {
    color: 'blue',
    fontWeight: 'semibold'
  }
}

const enclosed = {
  tab: {
    _selected: {
      _dark: { bg: 'joeDark.700' },
      bg: 'joeLight.300',
      border: 0,
      color: 'textPrimary'
    },
    border: 0,
    borderTopRadius: '2xl',
    color: 'textSecondary',
    fontWeight: 'semibold',
    padding: 4
  },
  tablist: {
    border: 0
  },
  tabpanels: {
    _dark: { bg: 'joeDark.700' },
    bg: 'joeLight.300'
  }
}

const softRoundedBase = {
  tab: {
    _dark: {
      _selected: { bg: 'joeDark.500', color: 'white' },
      color: 'joeDark.300'
    },
    _selected: {
      bg: 'joeLight.600',
      color: 'textPrimary'
    },
    borderRadius: { base: 'md', md: 'xl' },
    color: 'joeLight.700',
    fontSize: 'md'
  },
  tablist: {
    _dark: {
      borderColor: 'joeDark.500'
    },
    border: '1px',
    borderColor: 'joeLight.600',
    borderRadius: { base: 'md', md: '2xl' },
    height: 12,
    padding: '4px',
    size: { base: 'sm', md: 'md' }
  }
}

const softRoundedWhite = {
  ...softRoundedBase,
  tab: {
    ...softRoundedBase.tab,
    _selected: {
      ...softRoundedBase.tab._selected,
      bg: 'joeLight.400'
    }
  },
  tablist: {
    ...softRoundedBase.tablist,
    borderColor: 'border'
  }
}

export const tabsTheme = defineMultiStyleConfig({
  baseStyle,
  variants: {
    enclosed,
    'soft-rounded-white': softRoundedWhite
  }
})
